import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import LoginView from '../views/LoginView.vue'
import ProjectsView from '../views/ProjectsView.vue'
import ProjectDetailsView from '../views/ProjectDetailsView.vue'
import TrialConfigView from '../views/TrialConfigViewRefactor.vue'
import SubjectResultsView from '../views/SubjectResultsView.vue'
import ProjectResultsView from '../views/ProjectResultsView'
import ConfigureMultipleTrialsView from '../views/ConfigureMultipleTrialsView'

Vue.use(VueRouter)
  const getNestedAttr = (ob,attr) => {
    let parts = attr.split('.')
    while(parts.length){
      ob = ob[parts[0]]
      parts.shift()
    }
    return ob
  }
  const getParamAttr = (ob,param,attr) => {
    return ob && ob[param] && getNestedAttr(ob[param],attr) || '...'
  }

  const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: {
      hideHeader: true
    }
  },
  {
    path: '/',
    name: 'ProjectsView',
    component: ProjectsView,
    meta: {
      breadcrumbsFn: params => ({
        text: '',
        to: '/'
      })
    }
  },
  // {
  //   path: '/trial',
  //   name: 'TrialsView',
  //   component: TrialsView,
  //   meta: {
  //     breadcrumbsFn:  params => ({
  //       text: 'My trials',
  //       to: '/'
  //     })
  //   }
  // },
  {
    path: '/project/:project',
    name: 'ProjectDetailsView',
    component: ProjectDetailsView,
    meta: {
      breadcrumbsFn: params => ({
        text: `${getParamAttr(params,'project','name') || 'Untitled project'}`,
        to: `/project/${getParamAttr(params,'project','id')}`
      }),
      parentView: 'ProjectsView'
    },

  },
  {
    path: '/project/:project/results',
    name: 'ProjectResultsView',
    alias: ['/project/:project/results/:trial'],
    component: ProjectResultsView,
    meta: {
      breadcrumbsFn: params => 
        ({
          text: `Project results`,
          to: `/project/${getParamAttr(params,'project','id')}/results`
        }),
      parentView: 'ProjectDetailsView',
    },    
  },
  {
    path: '/project/:project/results/trial/:trial/subject/:subject',
    name: 'SubjectResultsView',
    component: SubjectResultsView,
    meta: {
      breadcrumbsFn: params => ({
        text: `Subject ${getParamAttr(params,'subject','subject.templateId')}`,
        to: `/project/${getParamAttr(params,'project','id')}/results/trial/${getParamAttr(params,'trial','id')}/subject/${getParamAttr(params,'subject','templateId')}`
      }),
      parentView: 'ProjectResultsView'
    }
  },
  {
    path: '/project/:project/generate',
    name: 'ConfigureMultipleTrialsView',
    component: ConfigureMultipleTrialsView,
    meta: {
      breadcrumbsFn: params => ({
        text: `Configure Trials`,
        to: `/project/${getParamAttr(params,'project','id')}/generate`
      }),
      parentView: 'ProjectDetailsView'

    },
  },
  {
    path: '/project/:project/trial/:trial',
    name: 'TrialEditView',
    component: TrialConfigView,
    meta: {
      breadcrumbsFn: params => ({
        text: `${getParamAttr(params,'trial','name') || 'Untitled trial'}`,
        to: `/project/${getParamAttr(params,'project','id')}/trial/${getParamAttr(params,'trial','id')}`
      }),
      parentView: 'ProjectDetailsView'
    },
  },
  
  {
    path: '*',
    name: 'ProjectsView',
    component: ProjectsView
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)

  const loggedIn = localStorage.getItem('elem-session-token')

  if (authRequired && !loggedIn) {
    return next('/login')
  } else {
    if(loggedIn && !store.state.trialOptions.loaded) store.dispatch('trialOptions/loadAll')
    if(loggedIn && !store.state.projectFields.loaded) store.dispatch('projectFields/load')
    store.dispatch('paramsData/set',to.params)
    next()
  }
})

export default router
